import { useSelector } from 'react-redux';
import * as EncryptedKey from '../constants/encryptedRootReducerKeys';

export const useSuperVisorSelector = () => {

	const patientNewRxDataResponse = useSelector((state) => state.patientNewRxData)
	const UpdateNewRXDataOptionResponse = useSelector(state => state.UpdateNewRXDataOption)
	const patientDeliveredListResponse = useSelector((state) => state[EncryptedKey.patientDeliveredDataBasisOfRoute]);

	const PatientListWithoutPharmacistSignResponse = useSelector(state => state.PatientListWithoutPharmacistSign)
	const UpdatePharmacistSignatureResponse = useSelector(state => state.UpdatePharmacistSignature)

	const updatedDefaultPharmacistResponse = useSelector(state => state.updatedDefaultPharmacist)
	const pharmacyMarkAttandanceResponse = useSelector(state => state.pharmacyMarkAttandance)

	const pendingCounsellingResponse = useSelector(state => state.pendingCounselling)
	const allPharmacistListResponse = useSelector(state => state.pendingCounselling.allPharmacist)
	const savePharmacistForDriverResponse = useSelector(state => state.pendingCounselling.savePharmacistForDriver)
	const pharmacyHasLinkedOtpResponse = useSelector(state => state.pendingCounselling.pharmacyHasLinkedOtp)
	const flexiMarkedNotificationsResponse = useSelector(state => state.pendingCounselling.flexiMarkedNotifications.data)

	return {
		patientNewRxDataResponse,
		UpdateNewRXDataOptionResponse,
		patientDeliveredListResponse,
		PatientListWithoutPharmacistSignResponse,
		UpdatePharmacistSignatureResponse,
		updatedDefaultPharmacistResponse,
		pharmacyMarkAttandanceResponse,
		pendingCounsellingResponse,
		allPharmacistListResponse,
		savePharmacistForDriverResponse,
		pharmacyHasLinkedOtpResponse,
		flexiMarkedNotificationsResponse
	}
}